import { t } from '@/i18n';
import { z } from 'zod';

const ACCEPTED_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png'];

export const modalFormSchema = z.object({
  type: z.enum(['player', 'staff']),
  team_uuid: z.string().optional(),
  group_uuid: z.string().min(1, t('pages.application_roster_member.components.schema.roster_member_schema_required')),
  name: z.string().min(1, t('pages.application_roster_member.components.schema.roster_member_schema_required')),
  role_label: z.string().optional(),
  hyperlink: z.string().optional(),
  shirt_number: z.string().optional(),
  birthdate: z.string().optional(),
  age: z.string().optional(),
  nationality: z.string().optional(),
  height: z.string().optional(),
  contract_until: z
    .string()
    .nullish()
    .transform(v => v ?? ''),
  image: z
    .any()
    .refine(
      file => (file && ACCEPTED_IMAGE_TYPES.includes(file.type)) || !file,
      t('pages.application_roster_member.components.schema.roster_member_schema_invalid_file_extension'),
    ),
  stats: z
    .object({
      matches: z.coerce.number().min(0).default(0),
      wins: z.coerce.number().min(0).default(0),
      draw: z.coerce.number().min(0).default(0),
      lose: z.coerce.number().min(0).default(0),
      goals: z.coerce.number().min(0).default(0),
      assists: z.coerce.number().min(0).default(0),
      total_shots: z.coerce.number().min(0).default(0),
      shots_on_target: z.coerce.number().min(0).default(0),
      yellow_cards: z.coerce.number().min(0).default(0),
      red_cards: z.coerce.number().min(0).default(0),
      goals_conceded: z.coerce.number().min(0).default(0),
    })
    .default({}),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
